/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskProgress
 */
export interface TaskProgress {
    /**
     * 
     * @type {string}
     * @memberof TaskProgress
     */
    message?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TaskProgress
     */
    current?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TaskProgress
     */
    max?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskProgress
     */
    bar?: boolean | null;
}

export function TaskProgressFromJSON(json: any): TaskProgress {
    return TaskProgressFromJSONTyped(json, false);
}

export function TaskProgressFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskProgress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
        'current': !exists(json, 'current') ? undefined : json['current'],
        'max': !exists(json, 'max') ? undefined : json['max'],
        'bar': !exists(json, 'bar') ? undefined : json['bar'],
    };
}

export function TaskProgressToJSON(value?: TaskProgress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'current': value.current,
        'max': value.max,
        'bar': value.bar,
    };
}


